import React, { useEffect, useRef, useState } from "react";
import {
  Paper,
  Typography,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
  Checkbox,
  Box,
  Grid,
  Button,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/system";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import CustomizedProgressBars from "../CustomizedProgressBars";
import axios from "axios";
import { Download, Delete } from "@mui/icons-material";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import { initializeApp } from "firebase/app";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CircularProgress from "@mui/material/CircularProgress";
import PageNotFound from "../404";
import Navbar from "../Navbar";
import Footer from "../Footer";
import QueryBuilderOutlinedIcon from "@mui/icons-material/QueryBuilderOutlined";
import jsPDF from "jspdf";
import "jspdf-autotable";
import BrowserUpdatedIcon from "@mui/icons-material/BrowserUpdated";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts"; // Import fonts
import { firebaseConfig, validateContestSession } from "../../../Utility/Helper";
import moment from "moment";

const FormPreview = () => {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const pdfRef = useRef();
  const printRef = useRef(); // Reference to the printable area
  const [searchParams] = useSearchParams();
  const trackCode = searchParams.get("track");
  const navigate = useNavigate();
  const { contestId } = useParams();
  const [loading, setLoading] = useState(true);
  const [formStatus, setFormStatus] = useState("");
  const [title, setTitle] = useState("");
  const [data, setData] = useState({
    registrationId: "12345",
    firstName: "John",
    lastName: "Doe",
    companyName:
      "Example Corp - A Really Long Company Name That Should Span Full Width",
    email: "john.doe@example.com",
    phoneNumber: "123-456-7890",
    sector: "Technology",
    stage: "Startup",
    state: "California",
    businessStructure: "LLC",
    hearAboutUs: "Social Media",
    answerFields: {
      userAnswer: [
        {
          value: "Section 1",
          elements: [
            { value: "Question 1", answer: "Answer 1", type: "text" },
            {
              value: "Question 2",
              answer: ["Answer 2a", "Answer 2b"],
              type: "text",
            },
          ],
        },
        {
          value: "Section 2",
          elements: [
            { value: "Question 3", answer: "Answer 3", type: "text" },
            { value: "Question 4", answer: "Answer 4", type: "text" },
          ],
        },
      ],
    },
  });

  const [urlValid, setUrlValid] = useState(false);

  const validationURL = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/application/get-limited-contest-data/${contestId}`,
        {
          headers: {
            "Cache-Control": "no-cache",
          },
        },
      );
      if (response.ok) {
        setUrlValid(true);
      } else {
        setUrlValid(false);
        localStorage.clear();
        const navigatePath = trackCode
          ? `/login/${contestId}?track=${trackCode}`
          : `/login/${contestId}`;

        navigate(navigatePath);

        // navigate(`/login/${contestId}`);

        throw new Error("Failed to fetch data");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Please Check The URL, It`s Not a Valid Url", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
        hideProgressBar: true,
      });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    validationURL();
  }, [contestId, navigate]);

  const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  }));

  const SectionBox = styled(Box)(({ theme }) => ({
    width: "100%",
    padding: theme.spacing(1),
    backgroundColor: "#CDD8DB",
    marginBottom: theme.spacing(2),
    borderRadius: "8px", // Add border radius
  }));

  const handleBack = () => {
    const navigatePath = trackCode
      ? `/dashboard/${contestId}?track=${trackCode}`
      : `/dashboard/${contestId}`;

    navigate(navigatePath);
    // navigate(`/dashboard/${contestId}`);
  };

  // Firebase

  const handleSubmit = async () => {
    try {

      if (!validateContestSession(contestId)) {
              return;
            }


      setLoading(true);

      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/application/${userData.userId}`,
        {
          status: "submit",
          reviewStatus: "inReview",
        },
        {
          headers: {
            Authorization: `Bearer ${userData.accessToken}`,
            "Cache-Control": "no-cache",
          },
        },
      );
      if (response.status >= 200 && response.status < 210) {
        setLoading(false); // Set loading to false when fetching data is completed successfully

        toast.success("You have submitted the application successfully. ", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
          hideProgressBar: true,
        });
        fetchData();
        const navigatePath = trackCode
          ? `/dashboard/FormPreview/${userData.contestId}?track=${trackCode}`
          : `/dashboard/FormPreview/${userData.contestId}`;

        navigate(navigatePath);
        // navigate(`/dashboard/FormPreview/${userData.contestId}`);
      }
    } catch (error) {
      setLoading(false); // Set loading to false when fetching data is completed successfully

      toast.error(error?.response?.data?.message[0], {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
        hideProgressBar: true,
      });
    }
  };

  const userData = JSON.parse(localStorage.getItem("user"));
  const fetchData = async () => {
    try {
      const accessToken = userData.accessToken;

      const profileResponse = await fetch(
        `${process.env.REACT_APP_BASE_URL}/application/profile-info`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Cache-Control": "no-cache",
          },
        },
      );
      if (!profileResponse.ok) {
        throw new Error("Failed to fetch profile data");
      } else {
        const profileData = await profileResponse.json();
        setLoading(false);
        setData(profileData);
        setTitle(profileData?.answerFields?.title || "");
        setFormStatus(profileData?.status);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  if (loading) {
    return (
      <>
        <CustomizedProgressBars />
      </>
    );
  }

  // to unable to edit
  const handleLogout = () => {
    // Clear localStorage
    localStorage.clear();
    // Navigate to logout route
    toast.success("Logged Out Successfully", {
      position: "top-right",
      autoClose: 3000,
      theme: "colored",
      hideProgressBar: true,
    });
    const navigatePath = trackCode
      ? `/login/${contestId}?track=${trackCode}`
      : `/login/${contestId}`;

    navigate(navigatePath);
    // navigate(`/login/${contestId}`);
  };
  // const firebaseConfig = {
  //   apiKey: "AIzaSyBsBCvETwSme2U56UTSpcEeyYB7964tUJI",
  //   authDomain: "iimcip-from-builder.firebaseapp.com",
  //   projectId: "iimcip-from-builder",
  //   storageBucket: "iimcip-from-builder.appspot.com",
  //   messagingSenderId: "413495634439",
  //   appId: "1:413495634439:web:33c631c502609ac519d8a2",
  //   measurementId: "G-5KH1RCS0ST",
  // };

  // const app = initializeApp(firebaseConfig);
  // const storage = getStorage(app);

  // const handleDownload = (answer) => {

  //   getDownloadURL(
  //     ref(
  //       storage,
  //       `/${userData.contestId}/${answer.uploadedFileName}`
  //     )
  //   )
  //     .then((url) => {
  //       // Create an anchor element
  //       const downloadLink = document.createElement("a");
  //       downloadLink.href = url;
  //       // Set the download attribute to force download
  //       downloadLink.setAttribute("download", "originalFileName"); // Set custom file name
  //       // Append the anchor element to the document body
  //       document.body.appendChild(downloadLink);
  //       // Trigger a click event on the anchor element to start download
  //       downloadLink.click();
  //       // Remove the anchor element from the document body after download
  //       document.body.removeChild(downloadLink);
  //     })
  //     .catch((error) => {
  //       // Handle any errors
  //     });
  // };

  // create new page then downloading
  // const handleDownload = async (answer) => {

  //   try {
  //     // Initialize Firebase Storage
  //     const firebaseConfig = {
  //       apiKey: "AIzaSyBsBCvETwSme2U56UTSpcEeyYB7964tUJI",
  //       authDomain: "iimcip-from-builder.firebaseapp.com",
  //       projectId: "iimcip-from-builder",
  //       storageBucket: "iimcip-from-builder.appspot.com",
  //       messagingSenderId: "413495634439",
  //       appId: "1:413495634439:web:33c631c502609ac519d8a2",
  //       measurementId: "G-5KH1RCS0ST",
  //     };

  //     const app = initializeApp(firebaseConfig);
  //     const storage = getStorage(app);
  //     // Get a reference to the file
  //     const fileRef = ref(
  //       storage,
  //       `/${userData.contestId}/${answer.uploadedFileName}`
  //     );

  //     // Get the download URL for the file
  //     const downloadURL = await getDownloadURL(fileRef);

  //     // Initiate the file download
  //     window.open(downloadURL);
  //   } catch (error) {
  //     console.error("Error downloading file:", error);
  //     // Handle errors
  //   }
  // };

  //Download Without creating the new window for download

  const handleDownload = async (answer) => {
    try {
      const app = initializeApp(firebaseConfig);
      const storage = getStorage(app);

      // Get a reference to the file
      const fileRef = ref(
        storage,
        `/${userData.contestId}/${answer.uploadedFileName}`,
      );

      // Get the download URL for the file
      const downloadURL = await getDownloadURL(fileRef);

      // // Create a hidden link element
      // const link = document.createElement("a");
      // link.href = downloadURL;
      // link.download = answer.originalFileName;
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
      // Initiate the file download
      window.open(downloadURL);
      toast.success("File Downloaded Successfully", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
        hideProgressBar: true,
      });
    } catch (error) {
      console.error("Error downloading file:", error);
      toast.error("Error While File Downloading", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
        hideProgressBar: true,
      });
      // Handle errors
    }
  };

  // DOwnload first page in every row 1 data
  // const downloadPDF = () => {
  //   const pdf = new jsPDF("p", "mm", "a4");

  //   // Set margins and page dimensions
  //   const margin = 10;
  //   const pageWidth = pdf.internal.pageSize.getWidth();
  //   const usableWidth = pageWidth - 2 * margin;

  //   // First page: Applicant Details
  //   pdf.setFontSize(20); // Increased font size
  //   pdf.setFont("bold");
  //   const applicantDetailsTitle = `Applicant Details (Reg Id - ${data?.registrationId})`;
  //   const applicantDetailsTitleWidth =
  //     (pdf.getStringUnitWidth(applicantDetailsTitle) *
  //       pdf.internal.getFontSize()) /
  //     pdf.internal.scaleFactor;
  //   const applicantDetailsTitleX = (pageWidth - applicantDetailsTitleWidth) / 2;
  //   pdf.setTextColor(0, 0, 128); // Navy blue font color
  //   pdf.text(applicantDetailsTitle, applicantDetailsTitleX, margin + 10);

  //   // Add underline below the title
  //   const applicantDetailsLineY = margin + 15; // Adjust the Y position based on your layout
  //   const applicantDetailsLineWidth =
  //     (pdf.getStringUnitWidth(applicantDetailsTitle) *
  //       pdf.internal.getFontSize()) /
  //     pdf.internal.scaleFactor;
  //   pdf.setLineWidth(0.5);
  //   pdf.setDrawColor(26, 50, 128); // Navy blue color for underline
  //   pdf.line(
  //     applicantDetailsTitleX,
  //     applicantDetailsLineY,
  //     applicantDetailsTitleX + applicantDetailsLineWidth,
  //     applicantDetailsLineY
  //   );

  //   // Applicant details table
  //   const applicantDetailsTableRows = [
  //     [
  //       {
  //         content: `First Name - ${data?.firstName}`,
  //         styles: { fontStyle: "bold" },
  //       },
  //     ],
  //     [
  //       {
  //         content: `Last Name - ${data?.lastName}`,
  //         styles: { fontStyle: "bold" },
  //       },
  //     ],
  //     [
  //       {
  //         content: `Company Name - ${data?.companyName}`,
  //         styles: { fontStyle: "bold" },
  //       },
  //     ],
  //     [
  //       {
  //         content: `Sector - ${data?.sector}`,
  //         styles: { fontStyle: "bold" },
  //       },
  //     ],
  //     [
  //       {
  //         content: `Stage - ${data?.stage}`,
  //         styles: { fontStyle: "bold" },
  //       },
  //     ],
  //     [
  //       {
  //         content: `Location/State - ${data?.state}`,
  //         styles: { fontStyle: "bold" },
  //       },
  //     ],
  //     [
  //       {
  //         content: `Business Structure - ${data?.businessStructure}`,
  //         styles: { fontStyle: "bold" },
  //       },
  //     ],
  //     [
  //       {
  //         content: `Email - ${data?.email}`,
  //         styles: { fontStyle: "bold" },
  //       },
  //     ],
  //     [
  //       {
  //         content: `Mobile Number - ${data?.phoneNumber}`,
  //         styles: { fontStyle: "bold" },
  //       },
  //     ],
  //     [
  //       {
  //         content: `Where do you hear about us? - ${data?.hearAboutUs}`,
  //         styles: { fontStyle: "bold" },
  //       },
  //     ],
  //   ];

  //   pdf.autoTable({
  //     body: applicantDetailsTableRows,
  //     startY: margin + 30,
  //     theme: "plain",
  //     styles: {
  //       cellPadding: 2, // Reduced cell padding to decrease row spacing
  //       fontSize: 14, // Increased font size for better readability
  //       halign: "left",
  //       textColor: [0], // Black font color
  //     },
  //     columnStyles: {
  //       0: { cellWidth: usableWidth, valign: "middle" },
  //     },
  //   });

  //   // Add a page break before starting "Application Details" section
  //   pdf.addPage();

  //   // Second page: Application Details
  //   pdf.setFontSize(22); // Set font size for Application Details
  //   pdf.setTextColor(26, 50, 128); // Set navy blue font color
  //   const applicationDetailsTitle = "Application Details";
  //   const applicationDetailsTitleWidth =
  //     (pdf.getStringUnitWidth(applicationDetailsTitle) *
  //       pdf.internal.getFontSize()) /
  //     pdf.internal.scaleFactor;
  //   const applicationDetailsTitleX =
  //     (pageWidth - applicationDetailsTitleWidth) / 2;
  //   pdf.text(applicationDetailsTitle, applicationDetailsTitleX, margin + 10);

  //   // Add underline below the title
  //   const applicationDetailsLineY = margin + 15; // Adjust the Y position based on your layout
  //   const applicationDetailsLineWidth =
  //     (pdf.getStringUnitWidth(applicationDetailsTitle) *
  //       pdf.internal.getFontSize()) /
  //     pdf.internal.scaleFactor;
  //   pdf.setLineWidth(0.5);
  //   pdf.setDrawColor(26, 50, 128); // Navy blue color for underline
  //   pdf.line(
  //     applicationDetailsTitleX,
  //     applicationDetailsLineY,
  //     applicationDetailsTitleX + applicationDetailsLineWidth,
  //     applicationDetailsLineY
  //   );

  //   // Table Columns for Application Details
  //   const tableColumn = ["", ""];
  //   const tableRows = [];

  //   // Populate Table Rows
  //   data?.answerFields?.userAnswer.forEach((section) => {
  //     // Section Header Row
  //     tableRows.push([
  //       {
  //         content: section.value,
  //         colSpan: 2,
  //         styles: {
  //           halign: "center",
  //           fillColor: [26, 50, 128], // Navy blue background
  //           textColor: [255, 255, 255], // White font color
  //           fontStyle: "bold",
  //         },
  //       },
  //     ]);

  //     // Section Elements Rows
  //     section.elements.forEach((element) => {
  //       let answer = element.answer;

  //       if (Array.isArray(answer)) {
  //         answer = answer.join(", ");
  //       }

  //       if (element.type === "file" || element.type === "audio") {
  //         answer = element.answer.originalFileName || "N/A";
  //       }

  //       tableRows.push([element.value, answer]);
  //     });
  //   });

  //   // Generate PDF Table for Application Details
  //   pdf.autoTable({
  //     head: [tableColumn],
  //     body: tableRows,
  //     startY: margin + 10, // Reduced space below the title
  //     theme: "plain",
  //     styles: {
  //       cellPadding: 5,
  //       fontSize: 10,
  //       halign: "left",
  //     },
  //     columnStyles: {
  //       0: { cellWidth: usableWidth / 2 },
  //       1: { cellWidth: usableWidth / 2 },
  //     },
  //     margin: { top: margin, left: margin, right: margin, bottom: margin },
  //     didDrawCell: (data) => {
  //       // Add a line below each section header row for separation
  //       if (
  //         data.row.raw[0] &&
  //         data.row.raw[0].styles &&
  //         data.row.raw[0].styles.fillColor
  //       ) {
  //         pdf.setDrawColor(26, 50, 128);
  //         pdf.setLineWidth(0.5);
  //         pdf.line(
  //           data.cell.x,
  //           data.cell.y + data.cell.height,
  //           data.cell.x + data.cell.width,
  //           data.cell.y + data.cell.height
  //         );
  //       }
  //     },
  //   });

  //   // Save the PDF
  //   pdf.save(`${data?.registrationId}.pdf`);
  // };

  // Download PDF first page divided in 2 column

  const downloadPDF = () => {
    const documentDefinition = {
      content: [
        // Image Logo
        {
          // Add logo to the top-left corner
          absolutePosition: { x: 49, y: 32 }, // Adjust position as needed

          image:
            "data:image/png;base64,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", // Replace with your base64 image string
          width: 50, // Width of the logo
          height: 50, // Height of the logo
        },
        {
          text: `Applicant Details (Reg Id - ${data.registrationId})`,
          fontSize: 22,
          bold: true,
          // color: "#2986ce",
          color: "#063970",
          alignment: "center",
          margin: [0, 10, 0, 10], // [left, top, right, bottom],
          // decoration: "underline", // Add underline
          //
        },
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 10,
              x2: 500,
              y2: 10,
              lineWidth: 0.5,
              lineColor: "navy",
            },
          ],
          margin: [0, 5, 0, 10], // [left, top, right, bottom]
        },
        {
          table: {
            widths: ["*", "*"], // Specify column widths
            body: [
              [
                {
                  text: [
                    { text: "Contest Name- ", bold: true, color: "#063970" },
                    { text: `${data.contestName}` },
                  ],
                  colSpan: 2,
                },
                {},
              ],
              [
                {
                  text: [
                    { text: "Applicant Name - ", bold: true, color: "#063970" },
                    { text: `${data.firstName} ${data.lastName}` },
                  ],
                  colSpan: 2,
                },
                {},
              ], // Full width for Name
              // To give background colour and font colour
              //    [
              //   {
              //     text: [
              //       { text: "Name - ", bold: true },
              //       { text: `${data.firstName} ${data.lastName}` },
              //     ],
              //     colSpan: 2,
              //     fillColor: "skyblue", // Background color
              //     color: "white", // Font color
              //     margin: [20, 0, 0, 0], // Add margin to the left
              //   },
              //   {},
              // ], // Full width for Name
              [
                {
                  text: [
                    { text: "Company Name - ", bold: true, color: "#063970" },
                    { text: data.companyName },
                  ],
                  colSpan: 2,
                },
                {},
              ], // Full width for Company Name
              [
                {
                  text: [
                    { text: "Email - ", bold: true, color: "#063970" },
                    { text: data.email },
                  ],
                  colSpan: 2,
                },
                {},
              ], // Full width for Email
              [
                {
                  text: [
                    { text: "Mobile Number - ", bold: true, color: "#063970" },
                    { text: data.phoneNumber },
                  ],
                  colSpan: 2,
                },
                {},
              ],
              ...(data.sector || data.stage
                ? [
                    [
                      {
                        text: [
                          { text: "Sector - ", bold: true, color: "#063970" },
                          { text: `${data.sector || ""}` },
                        ],
                        colSpan: 1,
                      },
                      {
                        text: [
                          { text: "Stage - ", bold: true, color: "#063970" },
                          { text: `${data.stage || ""}` },
                        ],
                        colSpan: 1,
                      },
                    ],
                  ]
                : []),
              ...(data.state || data.businessStructure
                ? [
                    [
                      ...(data.state
                        ? [
                            {
                              text: [
                                {
                                  text: "Location/State - ",
                                  bold: true,
                                  color: "#063970",
                                },
                                { text: `${data.state}` },
                              ],
                              colSpan: 1,
                            },
                          ]
                        : [{ text: "", colSpan: 1 }]),
                      ...(data.businessStructure
                        ? [
                            {
                              text: [
                                {
                                  text: "Business Structure - ",
                                  bold: true,
                                  color: "#063970",
                                },
                                { text: `${data.businessStructure}` },
                              ],
                              colSpan: 1,
                            },
                          ]
                        : [{ text: "", colSpan: 1 }]),
                    ],
                  ]
                : []),
              [
                {
                  text: [
                    {
                      text: "Where do you hear about us? - ",
                      bold: true,
                      color: "#063970",
                    },
                    { text: `${data.hearAboutUs}` },
                  ],
                  colSpan: 2,
                },
                {},
              ], // Where do you hear about us? with bold label and normal answer
            ],
          },
          layout: "noBorders",
          margin: [15, 20, 0, 10],
        },
        {
          text: "Answers Submitted By The User",
          fontSize: 21,
          bold: true,
          color: "#063970",
          alignment: "center",
          margin: [0, 10, 0, 5],
        },
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 10,
              x2: 500,
              y2: 10,
              lineWidth: 0.5,
              lineColor: "navy",
            },
          ],
          margin: [0, 5, 0, 10],
        },
        {
          table: {
            widths: ["*"],
            body: [
              ...data.answerFields.userAnswer.flatMap((section) => [
                [
                  {
                    stack: [
                      {
                        canvas: [
                          {
                            type: "rect",
                            x: 0,
                            y: 0,
                            w: 500,
                            h: 30,
                            r: 50, // Border radius
                            color: "#063970",
                          },
                          {
                            type: "rect",
                            x: 0,
                            y: 0,
                            w: 500,
                            h: 30,
                            r: 50, // Border radius
                            lineWidth: 2,
                            lineColor: "white",
                          },
                        ],
                      },
                      {
                        text: section.value,
                        bold: true,
                        color: "white",
                        margin: [15, -25, 0, 0], // Add margin to the left inside the rectangle and move text up
                      },
                    ],
                    margin: [10, 5, 0, 5],
                  },
                ],
                ...section.elements.map((element) => {
                  let answer = element.answer;
                  if (Array.isArray(answer)) {
                    answer = answer.join(", ");
                  }
                  if (element.type === "file" || element.type === "audio") {
                    answer = element.answer.originalFileName || "N/A";
                  }
                  const isClickableLink = element.type === "httplink";
                  return [
                    {
                      text: [
                        {
                          text: `${element.value}: `,
                          bold: true,
                          color: "#063970",
                        },
                        isClickableLink && answer
                          ? {
                              text: answer,
                              link: answer,
                              color: "blue",
                              decoration: "underline",
                            }
                          : { text: answer },
                      ],
                      margin: [35, 2, 2, 2], // Add margin to the left
                    },
                  ];
                }),
              ]),
            ],
          },
          layout: "noBorders",
        },
      ],
      defaultStyle: {
        fontSize: 14,
        columnGap: 10, // Optional: Adjust space between columns
      },
    };

    pdfMake
      .createPdf(documentDefinition)
      .download(`${data.registrationId}.pdf`);
  };

  const handlePrint = () => {
    // Create inline print styles
    const printStyles = `
      @media print {
        body * {
          visibility: hidden; /* Hide everything initially */
        }
        #printableArea, #printableArea * {
          visibility: visible; /* Show only the content in printRef */
        }
        #printableArea {
          position: absolute;
          left: 0;
          top: 0;
          width: 90%; /* Ensure it fits within the print margins */
          margin: 0 auto; /* Center the content */
          padding: 20px; /* Add padding to prevent content cutoff */
          box-sizing: border-box;
        }
        @page {
          margin: 20mm; /* Define margins for the printed page */
        }
        .no-print {
          display: none !important; /* Hide elements with no-print class */
        }
      }
    `;

    // Create a style tag and inject the print styles
    const styleTag = document.createElement("style");
    styleTag.type = "text/css";
    styleTag.innerHTML = printStyles;
    document.head.appendChild(styleTag);

    // Trigger the print dialog
    window.print();

    // Remove the style tag after printing is done
    document.head.removeChild(styleTag);
  };

  return (
    <>
      {urlValid ? (
        <>
          <Navbar />

          <div>
            {/* <Grid container spacing={2} justifyContent="center"   sx={{ margin: "auto", mt: 1, marginBottom: 3 }}>
        <Grid item xs={8} textAlign="center">
          {" "}

          <Typography variant="h4">
            <span
              style={{
                textDecoration: "underline",
                fontWeight: "bold",
                fontFamily: "Arial, sans-serif",
                color: "navy",
              }}
            >
              {title ? title : ""}
            </span>
          </Typography>
        
        </Grid>
      </Grid> */}
            <Grid
              container
              spacing={2}
              justifyContent="center"
              item
              xs={9}
              sx={{ margin: "auto", mt: 1, marginBottom: 8 }}
            >
              <Grid item xs={9}>
                <div
                  id="printableArea"
                  ref={printRef}
                  style={{ width: "100%" }}
                >
                  {data?.answerFields?.userAnswer.map((section, index) => (
                    <Grid
                      item
                      xs={12}
                      // Add class for conditional print background
                      key={`userAnswer-${index}-${section.id}`}
                    >
                      <SectionBox>
                        <Grid
                          container
                          // justifyContent="center"
                          alignItems="center"
                          sx={{
                            height: "auto",
                            minHeight: "50px",
                            width: "100%",
                            bgcolor: "#1A3280",
                            color: "white",
                            fontWeight: "bold",
                            borderRadius: "8px",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div style={{ flex: 1, textAlign: "center" }}>
                            <Typography variant="h5">
                              {section.value}
                            </Typography>
                          </div>
                          {/* Download Button */}
                          {index === 0 && (
                            <div
                              className="no-print"
                              style={{
                                textAlign: "right",
                                marginRight: "10px",
                              }}
                            >
                              <Tooltip title="Download Application">
                                {/* <Download
                                onClick={downloadPDF}
                                style={{
                                  cursor: "pointer",
                                }}
                              /> */}
                                <Download
                                  onClick={downloadPDF}
                                  style={{
                                    cursor: "pointer",
                                  }}
                                />
                              </Tooltip>
                            </div>
                          )}
                        </Grid>
                        <div>
                          {section.elements.map((element, ind) => (
                            <StyledPaper key={`elements-${ind}-${element.id}`}>
                              <Typography
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  whiteSpace: "pre-line",
                                }}
                                component={"div"}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <strong style={{ marginRight: "5px" }}>
                                    {element.required && (
                                      <span
                                        style={{
                                          marginRight: "5px",
                                          color: "red",
                                        }}
                                      >
                                        *
                                      </span>
                                    )}
                                    {element.value}&nbsp;-
                                  </strong>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: "13px",
                                    flexWrap: "wrap",
                                  }}
                                >
                                  {/* {element.type === "file" ||
                                  element.type === "audio" ? (
                                    <>
                                      {element.answer.originalFileName && (
                                        <>
                                          <span>
                                            {element.answer.originalFileName}
                                          </span>
                                          <Download
                                            onClick={() =>
                                              handleDownload(element.answer)
                                            }
                                            style={{
                                              cursor: "pointer",
                                              marginLeft: "5px",
                                            }}
                                          />
                                        </>
                                      )}
                                    </>
                                  ) : element.type === "check" ? (
                                    Array.isArray(element.answer) ? (
                                      <span>
                                        {element.answer.map((value, index) => (
                                          <React.Fragment key={`answe${index}`}>
                                            {index > 0 && ", "} {value}
                                          </React.Fragment>
                                        ))}
                                      </span>
                                    ) : (
                                      <span>{element.answer}</span>
                                    )
                                  ) : element.type === "rich" ? (
                                    // Render rich text content using dangerouslySetInnerHTML
                                    <div dangerouslySetInnerHTML={{ __html: element.answer }} />
                                  ) : element.type === "multi-select" ? (
                                    Array.isArray(element.answer) ? (
                                      <span>{element.answer.join(", ")}</span>
                                    ) : (
                                      <span>{element.answer}</span>
                                    )
                                  ) : (
                                    <span>{element.answer}</span>
                                  )} */}

                                  {element.type === "file" ||
                                  element.type === "audio" ? (
                                    <>
                                      {element.answer.originalFileName && (
                                        <>
                                          <span>
                                            {element.answer.originalFileName}
                                          </span>
                                          <Download
                                            onClick={() =>
                                              handleDownload(element.answer)
                                            }
                                            style={{
                                              cursor: "pointer",
                                              marginLeft: "5px",
                                            }}
                                          />
                                        </>
                                      )}
                                    </>
                                  ) : element.type === "check" ? (
                                    Array.isArray(element.answer) ? (
                                      <span>
                                        {element.answer.map((value, index) => (
                                          <React.Fragment key={`answe${index}`}>
                                            {index > 0 && ", "} {value}
                                          </React.Fragment>
                                        ))}
                                      </span>
                                    ) : (
                                      <span>{element.answer}</span>
                                    )
                                  ) : element.type === "rich" ? (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: element.answer,
                                      }}
                                    />
                                  ) : element.type === "multi-select" ? (
                                    Array.isArray(element.answer) ? (
                                      <span>{element.answer.join(", ")}</span>
                                    ) : (
                                      <span>{element.answer}</span>
                                    )
                                  ) : element.type === "date" ? (
                                    // Render the date using Moment.js in dd-mm-yyyy format
                                    <span>
                                      {moment(element.answer).format(
                                        "DD-MM-YYYY",
                                      )}{" "}
                                      <small>(Format: dd-mm-yyyy)</small>
                                    </span>
                                  ) : element.type === "bdate" ? (
                                    <span>
                                      {element.answer ? (
                                        <>
                                          {moment(element.answer).format(
                                            "DD-MM-YYYY",
                                          )}{" "}
                                          <small>(Format: dd-mm-yyyy)</small>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </span>
                                  ) : element.type === "link" ? (
                                    <a
                                      href={element.answer}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ color: "blue" }}
                                      download={element.answer.split("/").pop()} // Extracts file name from URL
                                    >
                                      {element.answer}{" "}
                                      {/* Displaying the file name */}
                                    </a>
                                  ) : element.type === "httplink" ? (
                                    element.answer ? (
                                      <a
                                        href={element.answer}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: "blue" }}
                                      >
                                        {element.answer}
                                      </a>
                                    ) : (
                                      <span></span>
                                    )
                                  ) : (
                                    <span>{element.answer}</span>
                                  )}

                                  {/* getting error not opening previous code changed some times form preview not coming changed on 05/July/2024*/}
                                  {/* element.type === "check" ? (
                                <span>
                                  {element.answer.map((value, index) => (
                                    <React.Fragment key={index}>
                                      {index > 0 && ", "} {value}
                                    </React.Fragment>
                                  ))}
                                </span>
                              ) : (
                                <span>{element.answer}</span>
                              )} */}
                                </div>
                              </Typography>
                            </StyledPaper>
                          ))}
                        </div>
                      </SectionBox>
                    </Grid>
                  ))}

                  <Grid
                    className="no-print"
                    item
                    xs={12}
                    sx={{ textAlign: "center", mb: 4 }}
                  >
                    {formStatus === "draft" ? (
                      <>
                        <Button
                          sx={{ mr: 2 }}
                          variant="outlined"
                          color="secondary"
                          onClick={handleBack}
                        >
                          Back
                        </Button>
                        <Button
                          sx={{ mr: 2 }}
                          variant="contained"
                          color="primary"
                          onClick={handleSubmit}
                        >
                          Submit
                        </Button>
                        {/* <Button
                      variant="contained"
                      color="primary"
                      onClick={handleLogout}
                    >
                      Logout
                    </Button> */}
                      </>
                    ) : (
                      <>
                        {/* <Button
                      variant="contained"
                      color="primary"
                      onClick={handleLogout}
                    >
                      Logout
                    </Button> */}
                      </>
                    )}
                  </Grid>
                </div>
              </Grid>
              {/* Right Side Form Status */}
              {data?.reviewStatus === "approved" ? (
                <Grid className="no-print" item xs={2}>
                  <SectionBox
                    sx={{
                      borderRadius: "8px",
                      marginLeft: "30px",
                      width: "160%",
                    }}
                  >
                    <Grid
                      container
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        height: "50px",
                        width: "100%",
                        bgcolor: "#1A3280",
                        color: "white",
                        fontWeight: "bold",
                        borderRadius: "8px",
                      }}
                    >
                      <Typography variant="h5">Form Status</Typography>
                    </Grid>
                    <Grid>
                      <StyledPaper>
                        <Typography
                          variant="body1"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          Contest Admin Approval
                          {data?.reviewStatus === "approved" ? (
                            <>
                              <CheckCircleIcon color="success" />
                            </>
                          ) : (
                            <>
                              <Tooltip title="Waiting For Admin to Approve">
                                <QueryBuilderOutlinedIcon
                                  sx={{ color: "disabled" }}
                                />{" "}
                              </Tooltip>
                            </>
                          )}
                        </Typography>
                      </StyledPaper>

                      <StyledPaper>
                        <Typography
                          variant="body1"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          Enumurator Approved
                          {data?.isEvaluated ? (
                            <CheckCircleIcon color="success" />
                          ) : (
                            <Tooltip title="Waiting For Enumurator to Approve the application">
                              <QueryBuilderOutlinedIcon
                                sx={{ color: "disabled" }}
                              />{" "}
                            </Tooltip>
                          )}
                        </Typography>
                      </StyledPaper>
                      <StyledPaper>
                        <Typography
                          variant="body1"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          Short List
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {/* <CheckCircleIcon sx={{ color: "disabled" }} /> */}
                            {data?.isShortListed ? (
                              data?.shortListedType
                            ) : (
                              <Tooltip title="Waiting For Shortlisting Data to Update">
                                <QueryBuilderOutlinedIcon
                                  sx={{ color: "disabled" }}
                                />{" "}
                              </Tooltip>
                            )}
                          </div>
                        </Typography>
                      </StyledPaper>
                    </Grid>
                  </SectionBox>
                </Grid>
              ) : null}
            </Grid>
          </div>
        </>
      ) : (
        <>
          <PageNotFound />
        </>
      )}
      {/* <Footer/> */}
    </>
  );
};

export default FormPreview;
